import { useCallback } from 'react'

import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

type UseLoadActiveQuoteApprovalAutomationVersionId = () => () => Promise<
  string | undefined
>

/**
 * Returns an automation version ID if there's an active automation configured with the
 * trigger type of QUOTE_REQUIRES_APPROVAL.
 *
 * Returns undefined if there is no automation, or an automation with no active version
 * with the trigger type of QUOTE_REQUIRES_APPROVAL.
 *
 * If the value returned by this loader is defined, this can be used to drive the UI for a user
 * who requires approval before publishing a quote
 */

export const useLoadActiveQuoteApprovalAutomationVersionId: UseLoadActiveQuoteApprovalAutomationVersionId =
  () => {
    const load = useCallback(async () => {
      const allAutomationVersionsRes =
        await dashboardv99990101Client.getAllAutomationVersions({
          active: true,
          triggerType: 'QUOTE_REQUIRES_APPROVAL'
        })

      if (allAutomationVersionsRes.error) {
        throw new Error('Unable to get automations')
      }

      const activeQuoteApprovalAutomation =
        allAutomationVersionsRes.data?.items[0]

      return activeQuoteApprovalAutomation?.id
    }, [])

    return load
  }
